import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import {
  FormattedMessage,
  ContentDropdown,
} from "@learningblocks/shared-components";
import cn from "./style.module.scss";
import { useIntl } from "react-intl";
import { sanitizeConfigOptions } from "@labxchange/util-sanitization";

const TYPE_OBJECT = "object";

/**
 * NotebookImage:
 *  - Component to display Images in Notebook [Experimental Designs]
 *  - Display Image with/without caption
 */
export function NotebookImage(props) {
  const intl = useIntl(); // current language = intl.locale

  const className = `${cn.image} ${props.className} notebook-image-component`;

  const [imageSrc, setImageSrc] = useState(
    props.preview
      ? props.image.url
      : props.image.src.includes("images/")
        ? props.image.src
        : window.location.origin +
          window.location.pathname +
          `locales/${intl.locale}/images/${props.image.src}`
  );

  // When the image load errors, set the src to use the English path
  const handleImageError = () => {
    props.preview
      ? props.image.url
      : props.image.src.includes("images/")
        ? setImageSrc(props.image.src)
        : setImageSrc(
            window.location.origin +
              window.location.pathname +
              `locales/en/images/${props.image.src}`
          );
  };

  // When the language changes, set the image src to use the respective laguage path
  useEffect(() => {
    props.preview
      ? props.image.url
      : props.image.src.includes("images/")
        ? setImageSrc(props.image.src)
        : setImageSrc(
            window.location.origin +
              window.location.pathname +
              `locales/${intl.locale}/images/${props.image.src}`
          );
  }, [intl.locale]);

  if (typeof props.image === TYPE_OBJECT) {
    return (
      <figure className={className}>
        <Image
          src={imageSrc}
          alt={
            props.image.altText !== "" && props.image.altText !== undefined
              ? FormattedMessage({
                  string: props.image.altText,
                })
              : ""
          }
          onError={() => handleImageError()}
          width="100%"
        />
        {props.image.caption !== "" && props.image.caption !== undefined ? (
          <div className={cn.figcaption}>
            <FormattedMessage
              string={props.image.caption}
              sanitizeConfig={sanitizeConfigOptions.InlineText}
              description=""
            />
          </div>
        ) : null}
        {props.image.contentDropdown && props.image.contentDropdown.content ? (
          <ContentDropdown contentDetails={props.image.contentDropdown} />
        ) : null}
      </figure>
    );
  } else {
    return (
      <>
        <Image
          width="100%"
          src={props.image}
          alt={FormattedMessage({
            string: props.altText,
          })}
          className={className}
        />
      </>
    );
  }
}

NotebookImage.propTypes = {
  className: PropTypes.string,
  image: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      src: PropTypes.string,
      altText: PropTypes.string,
      caption: PropTypes.string,
    }),
  ]),
  preview: PropTypes.bool,
};

NotebookImage.defaultProps = {
  className: "",
  preview: false,
};
